import React, { FC, Suspense } from 'react'
import { CircularProgress } from '@mui/material'

import {
	SidebarChatMessagesBodyLoader,
	SidebarChatMessagesOpenButton,
} from './styled'
import AppPopover from '../../../../../../components/AppPopover'
import SidebarChatMessagesBadge from './SidebarChatMessagesBadge'
import theme from '../../../../../../theme'

const SidebarChatMessagesBody = React.lazy(
	() =>
		import(
			/* webpackChunkName: "recently_messages_popover" */ './SidebarChatMessagesBody'
		)
)

const popoverSx = {
	ml: 4,
	mb: 13,
	'& .MuiPaper-root': {
		borderRadius: '1rem',
		overflow: 'hidden',
		display: 'flex',
		flexDirection: 'column',
		width: '32rem',
		[theme.breakpoints.down('xl')]: {
			width: '26rem',
		},
	},
}

const SidebarChatMessages: FC = () => {
	return (
		<AppPopover
			popoverProps={{
				anchorOrigin: {
					vertical: 'center',
					horizontal: 'right',
				},
				transformOrigin: {
					vertical: 'center',
					horizontal: 'left',
				},
				marginThreshold: 34,
				sx: popoverSx,
			}}
			renderOpenButton={(onClick, open) => (
				<SidebarChatMessagesOpenButton
					aria-label='open chat messages popup'
					aria-describedby={'open chat messages popup'}
					onClick={onClick}
					open={open}
				>
					<SidebarChatMessagesBadge />
				</SidebarChatMessagesOpenButton>
			)}
		>
			<Suspense
				fallback={
					<SidebarChatMessagesBodyLoader>
						<CircularProgress />
					</SidebarChatMessagesBodyLoader>
				}
			>
				<SidebarChatMessagesBody />
			</Suspense>
		</AppPopover>
	)
}

export default SidebarChatMessages
